import {
  Slider as ReactAriaSlider,
  SliderFill as ReactAriaSliderFill,
  SliderThumb as ReactAriaSliderThumb,
  SliderTrack as ReactAriaSliderTrack,
  type SliderProps as ReactAriaSliderProps,
} from 'react-aria-components/Slider';

import css from './Slider.css';

interface SliderProps<T extends number | number[]>
  extends Pick<
    ReactAriaSliderProps<T>,
    'aria-label' | 'defaultValue' | 'maxValue' | 'minValue' | 'onChange' | 'onChangeEnd' | 'step' | 'value'
  > {
  thumbLabels: string[];
}

const Slider = <T extends number | number[]>({ thumbLabels, ...props }: SliderProps<T>) => {
  return (
    <ReactAriaSlider {...props}>
      <ReactAriaSliderTrack className={css.track}>
        {({ state }) => (
          <>
            <div className={css.trackInner}>
              <ReactAriaSliderFill className={css.trackFill} />
            </div>
            {state.values.map((_, i) => (
              <ReactAriaSliderThumb className={css.thumb} index={i} aria-label={thumbLabels?.[i]} key={i} />
            ))}
          </>
        )}
      </ReactAriaSliderTrack>
    </ReactAriaSlider>
  );
};

export default Slider;
